<template>
    <div class="text-container" :style="{'text-align': item.align}">
        <div v-html="item.content">

        </div>
    </div>
</template>

<script>

    export default {
        name: "TextItem",
        props: ["item"],
        data(){
            return{

            }
        }
    }
</script>

<style scoped>
    .text-container{
        position: relative;

    }

    .close-btn{
        position: absolute;
        top: -36px;
        right: 0;
        opacity: 0;
        transition: 0.3s;
    }

    .text-container:hover .close-btn{
        opacity: 1;
    }

    .close-btn:hover{
        opacity: 1;
    }

</style>